import axios from '@fs/zion-axios'
import { getUser } from '@fs/zion-user'
import { getSessionId } from '@fs/zion-session'

// Not using the default export so that we can add more
// methods to this utility later.
// eslint-disable-next-line import/prefer-default-export
export async function getMessageCounts() {
  const { cisId } = await getUser()
  const url = `/service/messaging/inbox/users/${cisId}/counters`
  return axios.get(url)
}

// check for all kinds of alerts, not just messages.
export async function getAlertsCounts() {
  const { cisId } = await getUser()
  const sessionId = getSessionId()
  const url = `/service/messaging/inbox/users/${cisId}/counters/tags`
  return axios
    .get(url, {
      headers: { Authorization: `bearer ${sessionId}` },
    })
    .then(({ data }) => [
      data.Conversations,
      Object.entries(data).reduce((total, entry) => (entry[0] === 'Conversations' ? total : total + entry[1]), 0),
    ])
}

const messageSummaries = ({ cisId, pageSize, page }) =>
  `/service/messaging/inbox/users/${cisId}/messages/threads?pageSize=${pageSize}&page=${page}`
export function getMessageSummaries({ pageSize, page }) {
  return getUserThreadSummaries({ url: messageSummaries, pageSize, page })
}

const notificationSummaries = ({ cisId, pageSize, page }) =>
  `/service/messaging/inbox/users/${cisId}/notifications/threads?pageSize=${pageSize}&page=${page}`
export function getNotificationSummaries({ pageSize, page }) {
  return getUserThreadSummaries({ url: notificationSummaries, pageSize, page })
}

async function getUserThreadSummaries({ url, pageSize, page }) {
  const { cisId } = await getUser()
  const response = await axios.get(url({ cisId, pageSize, page }))
  return response.data
}

/**
 * Gets an array of notification folder categories the user has muted.
 */
export async function getMutedNotifications() {
  try {
    const { cisId } = await getUser()
    const url = `/service/messaging/inbox/users/${cisId}/notifications/mutes`
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    return []
  }
}

/**
 * Gets an array of notification folder categories the user has muted.
 */
export async function getLastMessageAndNotificationTime() {
  try {
    const { cisId } = await getUser()
    const url = `/service/messaging/inbox/users/${cisId}/updatetimes`
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    // fail silently
    return {}
  }
}
